function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "self_review",
  "data-name": "self review",
  transform: "translate(-602.452 -1130)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19943",
  "data-name": "Group 19943",
  transform: "translate(-308.025 863.362)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_16942",
  "data-name": "Group 16942",
  transform: "translate(996.106 266.638)",
  opacity: 0.294
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_16960",
  "data-name": "Group 16960",
  transform: "translate(910.478 307.437)",
  opacity: 0.19
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518-2",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519-2",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2778",
  "data-name": "Ellipse 2778",
  transform: "translate(1011.984 340.313)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.16
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2779",
  "data-name": "Ellipse 2779",
  transform: "translate(1036.568 276.574)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.17
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2780",
  "data-name": "Ellipse 2780",
  transform: "translate(923.026 328.184)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.294
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_2216",
  "data-name": "Line 2216",
  x2: 31.609,
  transform: "translate(1019.775 297.921)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2217",
  "data-name": "Line 2217",
  x2: 33.988,
  transform: "translate(1019.435 307.437)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_3227",
  "data-name": "Ellipse 3227",
  transform: "translate(632 1138)",
  fill: "none",
  stroke: "#828b96",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 36,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 35,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "users-line",
  transform: "translate(650 1156.256)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31941",
  "data-name": "Path 31941",
  d: "M17.9,17.3A4.85,4.85,0,1,0,13,12.4,4.908,4.908,0,0,0,17.9,17.3Zm-.1-7.7h0a2.9,2.9,0,0,1,2.9,2.9,2.85,2.85,0,0,1-5.7,0,2.883,2.883,0,0,1,2.8-2.9Z",
  fill: "#f3994e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31942",
  "data-name": "Path 31942",
  d: "M32.7,16.7a9.9,9.9,0,0,0-7-2.5h-.8a6.667,6.667,0,0,1-.9,2.1,9.7,9.7,0,0,1,1.7-.1A8.317,8.317,0,0,1,31,17.8V25h2V17l-.3-.3Z",
  fill: "#f3994e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31943",
  "data-name": "Path 31943",
  d: "M23.4,7.8a2.442,2.442,0,1,1,4.5,1.9,2.5,2.5,0,0,1-2.2,1.5,1.7,1.7,0,0,1-.7-.1,7.084,7.084,0,0,1,.1,1.4v.6c.2,0,.4.1.6.1a4.45,4.45,0,0,0,.1-8.9A4.288,4.288,0,0,0,22,6.5a4.269,4.269,0,0,1,1.4,1.3Z",
  fill: "#f3994e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31944",
  "data-name": "Path 31944",
  d: "M12,16.4a6.667,6.667,0,0,1-.9-2.1h-.8a10.29,10.29,0,0,0-7,2.4L3,17v8H5V17.8a8.5,8.5,0,0,1,5.3-1.6A8.807,8.807,0,0,1,12,16.4Z",
  fill: "#f3994e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31945",
  "data-name": "Path 31945",
  d: "M10.3,13.1a1.268,1.268,0,0,0,.6-.1v-.6A6.15,6.15,0,0,1,11,11a1.7,1.7,0,0,1-.7.1,2.4,2.4,0,1,1,0-4.8,2.526,2.526,0,0,1,2.3,1.5,9.955,9.955,0,0,1,1.5-1.4,4.442,4.442,0,1,0-3.8,6.7Z",
  fill: "#f3994e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31946",
  "data-name": "Path 31946",
  d: "M26.1,22.7l-.2-.3A10.093,10.093,0,0,0,18.1,19a10.3,10.3,0,0,0-7.9,3.4l-.2.3v7.6A1.685,1.685,0,0,0,11.7,32H24.5a1.752,1.752,0,0,0,1.7-1.7V22.7Zm-2,7.3H12V23.4A8.534,8.534,0,0,1,18.1,21a8.065,8.065,0,0,1,6,2.4Z",
  fill: "#f3994e"
})));

function SvgSelfReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.946,
    height: 81.128,
    viewBox: "0 0 142.946 81.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfReview);
export default __webpack_public_path__ + "static/media/self-review.fae5c08a.svg";
export { ForwardRef as ReactComponent };